// filepath: apps/web/src/features/auth/CallbackRoute.tsx
//
// FR-UI-CORE-2 OIDC callback route component.
//
// Handles the OIDC redirect-back URL (?code=...&state=...). The
// `react-oidc-context` <AuthProvider> handles the actual code
// exchange automatically when the URL has these params — this
// component is rendered while the library is exchanging the code
// for tokens.
//
// The component renders the LoadingScreen until the auth state
// transitions to either authenticated or error. The App composition
// root handles the transition out of the callback route.

import React from "react";
import { useAuth } from "react-oidc-context";
import { LoadingScreen } from "@/auth";

export function CallbackRoute(): React.ReactElement {
  const auth = useAuth();

  // The library is mid-callback. Either auth.isLoading is true
  // (still exchanging) or auth.error is set (the exchange failed).
  // Either way, render the loading screen so the user has visual
  // feedback.
  if (auth.error) {
    // ISS-277: AuthStateRouter checks auth.error BEFORE dispatching
    // to this route, so this branch is defensively unreachable —
    // the parent renders OidcErrorScreen (AC-5) directly. Kept as
    // a guard so this component never paints the loading screen
    // over a failed exchange even if dispatched to directly.
    return <></>;
  }

  return <LoadingScreen />;
}
